/**
 * Created by piotr.pozniak@thebeaverhead.com on 24/08/2022
 */

import React, { useEffect } from "react";
import classNames from "classnames";
import { Link } from "react-router-dom";
import { updateJquery } from "../tools";

const CrownIcon = ({ className = "", tooltipMessage, children = null }) => {
  useEffect(() => {
    updateJquery();
  }, []);

  const tooltipProps = tooltipMessage
    ? {
        "data-toggle": "tooltip",
        "data-placement": "top",
        "data-custom-class": "tooltip-alert",
        title: tooltipMessage,
      }
    : {};
  return (
    <Link
      to={"/billing"}
      className={"visible d-flex align-items-center gap-xxs"}
    >
      <img
        src={"/img/crown.png"}
        className={classNames("crown", className)}
        {...tooltipProps}
      />
      {children}
    </Link>
  );
};

export default CrownIcon;
